import gql from 'graphql-tag';
import { ClientDepartment, ClientLocation } from 'api/fragments';

export default gql`
  fragment SearchAggregates on SearchAggregates {
    total
    departments {
      ...ClientDepartment
    }
    locations {
      ...ClientLocation
    }
  }
  ${ClientDepartment}
  ${ClientLocation}
`;
